import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
  emailStatisticDetail: state => state.emailStatisticDetail,
  emailStatisticDetailFlag: state => state.emailStatisticDetailFlag,
  emailStatisticGroup: state => state.emailStatisticGroup,
  emailStatisticGroupEvents: state => state.emailStatisticGroupEvents,
  emailGroupBy: state => state.emailGroupings.emailGroup,
  emailGroupByOptionally: state => state.emailGroupings.emailGroupByOptionally,
  emailGroupEventsByOptionally: state => state.emailGroupings.emailGroupEventsByOptionally,
  emailMessageCount: state => state.emailMessageCount,
  emailIncomingGroupBy: state => state.emailGroupings.emailGroupIncoming,
  emailDetailEvents: state => state.emailDetailEvents,
};
